<template>
    <div class="contact-map">
        <div class="container">
            <div v-if="locationData.additional_contact_maps.length">
                <div
                    class="row mb-50"
                    v-for="(additional_contact, index) in locationData.additional_contact_maps"
                    :key="index"
                >
                    <div class="col-l-4 col-m-4 col-s-12">
                        <div class="location location-info">
                            <h2
                                class="location-info__title"
                                v-if="additional_contact.hide_get_in_touch_label == false || index == 0"
                                v-html="locationData.contact_person.title"
                            ></h2>
                            <div class="location-info__adress" v-html="additional_contact.address"></div>
                        </div>
                    </div>
                    <div class="col-l-4 col-m-4 col-s-12">
                        <div class="location location-person">
                            <div class="location-person__image">
                                <img
                                    v-if="additional_contact.contact_person.photo.url"
                                    :src="additional_contact.contact_person.photo.url"
                                    alt="photo"
                                />
                            </div>
                            <div class="location-person__info">
                                <div
                                    class="location-person__name"
                                >{{ additional_contact.contact_person.name }}</div>
                                <div
                                    class="location-person__position"
                                >{{ additional_contact.contact_person.position }}</div>
                                <div class="location-person__email">
                                    <a
                                        :href="'mailto:'+additional_contact.contact_person.email"
                                    >{{ additional_contact.contact_person.email }}</a>
                                </div>
                                <div class="location-person__phone">
                                    <a
                                        :href="'tel:'+additional_contact.contact_person.phone"
                                    >{{ additional_contact.contact_person.phone }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-l-4 col-m-4 col-s-12">
                        <div class="location location-map">
                            <iframe
                                class="location-map__iframe"
                                style="border: 0;"
                                :src="additional_contact.map_link"
                                width="100%"
                                height="340"
                                frameborder="0"
                                allowfullscreen="allowfullscreen"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row mb-50">
                    <div class="col-l-4 col-m-4 col-s-12">
                        <div class="location location-info">
                            <h2
                                class="location-info__title"
                                v-html="locationData.contact_person.title"
                            ></h2>
                            <div class="location-info__adress" v-html="locationData.contact_person.adress"></div>
                        </div>
                    </div>
                    <div class="col-l-4 col-m-4 col-s-12">
                        <div class="location location-person">
                            <div class="location-person__image">
                                <img
                                    v-if="locationData.contact_person.photo.url"
                                    :src="locationData.contact_person.photo.url"
                                    alt="photo"
                                />
                            </div>
                            <div class="location-person__info">
                                <div
                                    class="location-person__name"
                                >{{ locationData.contact_person.name }}</div>
                                <div
                                    class="location-person__position"
                                >{{ locationData.contact_person.position }}</div>
                                <div class="location-person__email">
                                    <a
                                        :href="'mailto:'+locationData.contact_person.email"
                                    >{{ locationData.contact_person.email }}</a>
                                </div>
                                <div class="location-person__phone">
                                    <a
                                        :href="'tel:'+locationData.contact_person.phone"
                                    >{{ locationData.contact_person.phone }}</a>
                                </div>
                                <div class="location-person__additional-contact" v-html="locationData.contact_person.additional_contact_person">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-l-4 col-m-4 col-s-12">
                        <div class="location location-map">
                            <iframe
                                class="location-map__iframe"
                                style="border: 0;"
                                :src="locationData.map_link"
                                width="100%"
                                height="340"
                                frameborder="0"
                                allowfullscreen="allowfullscreen"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="form-wrapper" v-html="locationData.contact_form"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "contact-map",
    props: ["blockdata", "locationData"],
    mounted: function() {
        $("div.wpcf7 > form").each(function() {
            var $form = $(this);
            wpcf7.init($form[0]);
            if (wpcf7.cached) {
                wpcf7.refill($form);
            }
        });
    }
};
</script>



// WEBPACK FOOTER //
// ContactMap.vue?1483cd80